import axios from "@/api/config/request"
import { BASE_API } from './index'

/**
 * 企业授权应用资源树
 * @returns {Promise}
 */
export function getPermissionTree() {
  return axios.get(`${BASE_API}/permission/company/resource/trees`)
  // return axios.get(`/mock/trees.json`)
}

/**
 * 获取角色资源权限配置信息（用于回选）
 * @param {Object} params
 * @returns {Promise}
 */
export function getRolePermissionTree(params) {
  return axios.get(`${BASE_API}/permission/role/resource/config`, { params })
  // return axios.get(`/mock/roleTree.json`, { params })
}

/**
 * 授予角色资源权限(同时授权多个应用资源时)
 * @param {Array} data
 * @returns {Promise}
 */
export function grantRolePermission(data) {
  return axios.post(`${BASE_API}/permission/grant/role/resources`, data)
}

// 获取用户权限资源树
export function getUserPermissionTree() {
  return axios.get(`${BASE_API}/permission/user/resource/tree`)
}

// 企业授权应用列表
export function getAppList() {
  return axios.get(`${BASE_API}/permission/company/apps`)
}

// 为企业授权应用（开通应用）
export function grantAppPermission(data={}) {
  return axios.post(`${BASE_API}/permission/grant/company/app`, data)
}
